<template>
	<div class="slid-bar">
		<el-menu 
			:default-active="activeMenu" 
			class="el-menu-vertical-demo" 
			@open="handleOpen" 
			@close="handleClose"
			router
		>
			<el-menu-item index="/" @click="goto('/')">
				<i class="el-icon-location"></i>
				<span slot="title">首页</span>
			</el-menu-item>
			
			<template v-for="menu in menuList">
				<!-- 有子菜单的情况 -->
				<el-submenu v-if="menu.children && menu.children.length" :key="menu.id" :index="menu.id">
					<template slot="title">
						<i :class="menu.menuIcon || 'el-icon-location'"></i>
						<span>{{ menu.name }}</span>
					</template>
					<el-menu-item 
						v-for="child in menu.children" 
						:key="child.id" 
						:index="child.path"
						@click="goto(child.path)"
					>
						<i v-if="child.menuIcon" :class="child.menuIcon"></i>
						<span slot="title">{{ child.name }}</span>
					</el-menu-item>
				</el-submenu>
				
				<!-- 没有子菜单的情况 -->
				<el-menu-item v-else :key="menu.id" :index="menu.path" @click="goto(menu.path)">
					<i :class="menu.menuIcon || 'el-icon-location'"></i>
					<span slot="title">{{ menu.name }}</span>
				</el-menu-item>
			</template>
		</el-menu>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "SlidBar",
	
	data() {
		return {
			cachedMenuKey: null,  // 缓存菜单的标识
			cachedTreeData: []     // 缓存的树形数据
		};
	},
	
	computed: {
		...mapState({
			rawMenuList: state => state.menuList
		}),
		
		// 处理菜单数据，添加缓存避免重复构建树
		menuList() {
			// 没有数据时返回空数组
			if (!this.rawMenuList || this.rawMenuList.length === 0) {
				return [];
			}
			
			// 生成数据标识（用数据长度和JSON字符串的前100个字符作为标识）
			const dataKey = `${this.rawMenuList.length}_${JSON.stringify(this.rawMenuList.slice(0, 5))}`;
			
			// 如果数据没变化，返回缓存的树形数据
			if (this.cachedMenuKey === dataKey && this.cachedTreeData.length > 0) {
				return this.cachedTreeData;
			}
			
			// 构建新的树形数据
			this.cachedMenuKey = dataKey;
			this.cachedTreeData = this.buildTree(this.rawMenuList);
			
			return this.cachedTreeData;
		},
		
		// 当前激活的菜单项
		activeMenu() {
			const path = this.$route.path;
			return path;
		}
	},
	
	watch: {
		// 监听路由变化，可以在这里处理菜单高亮
		'$route.path': {
			handler(newPath) {
				// 可以在这里做一些路由变化时的处理
				console.log("当前路由:", newPath);
			},
			immediate: true
		}
	},
	
	methods: {
		handleOpen(key, keyPath) {
			console.log("菜单打开:", key, keyPath);
		},
		
		handleClose(key, keyPath) {
			console.log("菜单关闭:", key, keyPath);
		},
		
		goto(path) {
			if (path && path !== this.$route.path) {
				this.$router.push(path).catch(err => {
					// 避免重复跳转报错
					if (err.name !== 'NavigationDuplicated') {
						console.error("路由跳转失败:", err);
					}
				});
			}
		},
		
		// 构建树形结构
		buildTree(list, rootId = "0") {
			if (!list || !Array.isArray(list) || list.length === 0) {
				return [];
			}
			
			// 深拷贝，避免修改原数据
			const cloneList = JSON.parse(JSON.stringify(list));
			const map = {};
			const tree = [];
			
			// 建立 id 映射
			cloneList.forEach(item => {
				item.children = [];
				map[item.id] = item;
			});
			
			// 构建树
			cloneList.forEach(item => {
				const parentId = item.parentId;
				
				if (parentId === rootId || !map[parentId]) {
					// 根节点
					tree.push(item);
				} else {
					// 子节点
					const parent = map[parentId];
					if (parent) {
						parent.children.push(item);
					}
				}
			});
			
			// 排序（如果有 sortIndex 字段）
			tree.sort((a, b) => (a.sortIndex || 0) - (b.sortIndex || 0));
			tree.forEach(item => {
				if (item.children && item.children.length) {
					item.children.sort((a, b) => (a.sortIndex || 0) - (b.sortIndex || 0));
				}
			});
			
			console.log("构建的菜单树:", tree);
			return tree;
		}
	}
};
</script>

<style scoped>
.slid-bar {
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	overflow-y: auto;
}

/* 菜单样式优化 */
.slid-bar ::v-deep .el-menu {
	border-right: none;
}

.slid-bar ::v-deep .el-submenu .el-menu-item {
	min-width: 0;
	padding-left: 50px !important;
}

/* 滚动条样式 */
.slid-bar::-webkit-scrollbar {
	width: 6px;
}

.slid-bar::-webkit-scrollbar-thumb {
	background-color: #dcdfe6;
	border-radius: 3px;
}

.slid-bar::-webkit-scrollbar-track {
	background-color: #f5f7fa;
}
</style>